import { createFileRoute } from '@tanstack/react-router'

import { CollectionsScorecardScreen } from './-components/collections-scorecard-screen.tsx'

export const Route = createFileRoute('/collections/scorecard')({
  component: CollectionsScorecardScreen
})
